import React, { useEffect, useState } from "react";
import Layout from "../component/Layout/Layout";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/auth";
import axios from "axios";
import CountryPhone from "../component/CountryPhone";
import {RecaptchaVerifier, signInWithPhoneNumber} from 'firebase/auth'
import { auth } from '../component/login/firebase';
import OtpInput from 'react-otp-input';
import PasswordStrengthBar from 'react-password-strength-bar';
import IntlTelInputBox from "../component/login/IntlTelInputBox";
export default function MyAccountDetail() {
  const [lauth, setLauth] = useAuth();
  const [userId, setUserId] = useState(lauth?.user.id);
  const [details, setDetails] = useState({});
  const [oldDetails, setOldDetails] = useState({});
  const [nameUpdate, setNameUpdate] = useState('');
  const [phoneUpdate, setPhoneUpdate] = useState('');
  const[password, setPassword] = useState('');
  const[newPass, setNewPass] = useState('');
  const[confirmPass, setConfirmPass] = useState('');

  const[selectedCode, setSelectedCode] = useState('');
  const[country, setCountry] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [errMsg, setErrMsg] = useState({});
  const [otp, setOtp] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [fullPhone, setFullPhone] = useState('');
  const [otpTime, setOtpTime] = useState(40);
  const [recapGen, setRecapGen] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [hasFilled, setHasFilled] = useState(false);
  const getCustomerDetails = async()=>{
    setLoading(true)
    let {data} = await axios.get(`${process.env.REACT_APP_API_URL}/customer/info?customer_id=${userId}`);
    if(data){
      setDetails(data)
      setOldDetails(data)
      let c_code = data.c_code;
      let phone_full = data.phone;
      let phoneNo = phone_full.replace(c_code,'');
      setFullPhone(data.phone);
      setCountry(data.c_code);
      setSelectedCode(data.c_code)
      setPhoneNo(phoneNo)
      setLoading(false)
      //console.log('==',data)
    }
  }

  useEffect(()=>{
    getCustomerDetails();
  },[])

  useEffect(() => {
    if (otpTime > 0) {
      const intervalId = setInterval(() => {
        setOtpTime(otpTime - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [otpTime]);

  const handleChange = (e)=>{
    setErrMsg({});
    let value = e.target.value;
    let name = e.target.name;
    if(name==='phone'){
      setPhoneNo(value);
      let fullPhone = selectedCode+''+value;
      setDetails({
        ...details,
        [name]:fullPhone,
      })
    }else{
      setDetails({
        ...details,
        [name]:value
      })
    }
    
  }


  const checkUserExist = async (fullPhone)=>{
    try {
        let {data} = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`,{phone:fullPhone});
        //console.log(data); return false;
        if(data?.status){
            setErrMsg({cls:'alert alert-danger text-center', msg:"Phone number already exists"});
            return 'user';
        }else if(!data?.status){
            return 'guest';
        }
    } catch (error) {
        console.log(error)
    }
  }

  const updateUser = async(update_type)=>{
    try {
      setLoading(true);
      details.c_code=selectedCode;
      details.update_type=update_type;

      if(update_type==='name_update'){
        let nameError = '';
        if(details.f_name===''){
          nameError = 'First name is required.';
        }else if(details.l_name===''){
          nameError = 'Last name is required.';
        }else if(details.email===''){
          nameError = 'Email is required.';
        }else if(oldDetails.f_name===details.f_name && oldDetails.l_name===details.l_name && oldDetails. email===details.email){
          nameError = 'There is no any changes in the name or email, please change.';
        }

        if(nameError!==''){
          setErrMsg({cls:'alert alert-danger text-center', msg:nameError});
          setLoading(false);
          return;
        }
        
      }

      if(update_type==='phone_update'){
        details.phone=fullPhone;
      }

      let {data} = await axios.put(`${process.env.REACT_APP_API_URL}/customer/update-profile`, details);
        if(data?.status){
          getCustomerDetails();
          if(update_type==='name_update'){
            setNameUpdate(data?.message)
            setErrMsg({cls:'alert alert-success text-center', msg:data?.message});
          }else if(update_type==='phone_update'){
            setPhoneUpdate(data?.message)
            setErrMsg({cls:'alert alert-success text-center', msg:data?.message});
          }
        }

        setLoading(false);
    } catch (error) {
      //console.log(error)
      const {data} = error.response;
      setErrMsg('');
      setErrMsg({cls:'alert alert-danger text-center', msg:data.errors[0].message});
      setLoading(false);

    }
  }

  const updateUserPass = async(update_type)=>{
    setErrMsg({});
    try {
      setLoading(true);
      details.update_type=update_type;

      //console.log(details); return false;
      let current = details.password;
      let new_pass = details.newPass;
      let confirm_pass = details.confirmPass;
      //console.log(current); return false;
      if(current==='' || current===undefined){
        setErrMsg({cls:'alert alert-danger text-center', msg:'Current password can not be blank!'});
        setLoading(false);
        return false;
      }else if(new_pass===undefined || new_pass.length<8){
        setErrMsg({cls:'alert alert-danger text-center', msg:'New password length must be greater than or equal to 8 characters.'});
        setLoading(false);
        return false;
      }else if(confirm_pass===undefined || new_pass!==confirm_pass){
        setErrMsg({cls:'alert alert-danger text-center', msg:'Confirm password not match.'});
        setLoading(false);
        return false;
      }
      let {data} = await axios.put(`${process.env.REACT_APP_API_URL}/customer/update-profile`, details);
        if(data?.status){
          setLoading(false);
          if(update_type==='password_update'){
            setErrMsg({cls:'alert alert-success text-center', msg:data?.message});
            setLauth({
              ...lauth,
              user: null,
              token: "",
            });
            localStorage.removeItem("auth");
            localStorage.removeItem("cart");
            navigate('/login')
          }
        }else if(!data?.status){
          setLoading(false);
          if(update_type==='password_update'){
            setErrMsg({cls:'alert alert-danger text-center', msg:data?.message});
          }
        }
    } catch (error) {
      console.log(error)
    }
  }


  const handleSend = async(update_type)=>{
    try {
      setLoading(true);
      setErrMsg({});
        if(update_type==='phone_update'){
            if(phoneNo===''){
              setLoading(false);
              setErrMsg({cls:'alert alert-danger text-center', msg:'Mobile number is required.'});
              return;
            }else if(oldDetails.phone===fullPhone){
              setLoading(false);
              setErrMsg({cls:'alert alert-danger text-center', msg:'There is no any changes in the mobile number, please change.'});
              return;
            }else if(oldDetails.phone!==fullPhone){
              setLoading(false);
              const us = await checkUserExist(fullPhone);
              if(us==='user'){
                return;
              }
              //setErrMsg({cls:'alert alert-danger text-center', msg:'There is no any changes in the mobile number, please change.'});
              //return;              
            }
        }
        details.update_type=update_type;
       
      setErrMsg({cls:'alert alert-warning text-center', msg:"Please wait OTP sending..."});
      generateRecaptcha();
      setRecapGen(true);
      
      
      /* let full_phone = details.phone;
          setFullPhone(full_phone); */
          let full_phone = fullPhone;
          //setFullPhone(details.phone);
      let appVerifier = window.recaptchaVerifier;
      signInWithPhoneNumber(auth, full_phone, appVerifier)
        .then((confirmationResult) => {
          setLoading(true)
          setHasFilled(true);
          setOtpTime(40);
          setErrMsg({cls:'alert alert-success text-center', msg:"OTP Send successfully."});
          
          window.confirmationResult = confirmationResult;
          setLoading(false)
        }).catch((error) => {
          // Error; SMS not sent
          setLoading(false)
          setHasFilled(false);
          let err_msg = error?.message;
              err_msg = err_msg.includes('TOO_SHORT');
              err_msg = err_msg?'Invalid number, please check!':'Some thing went wrong, try again!';
          setErrMsg({cls:'alert alert-danger text-center', msg:err_msg});
          console.log(error);
        });
    } catch (error) {
      console.log(error)
    }
  }

    const resendOTP = async (event) => {
      setLoading(true)
      setErrMsg({});
      setOtp('')
      if (isButtonDisabled) {
        return;
      }
      setIsButtonDisabled(true);
      let appVerifier = window.recaptchaVerifier;
      signInWithPhoneNumber(auth, fullPhone, appVerifier)
        .then((confirmationResult) => {
          setLoading(false)
          setErrMsg({cls:'alert alert-success text-center', msg:"OTP resend successfully."});
          
          window.confirmationResult = confirmationResult;
          setOtpTime(40);
          setIsButtonDisabled(false);
        }).catch((error) => {
          setLoading(false)
          setErrMsg({cls:'alert alert-danger text-center', msg:"OTP not send please try again later!"});
          console.log(error);
        });
    };
   
    const generateRecaptcha = () => {
      if(!recapGen){
        window.recaptchaVerifier = new RecaptchaVerifier('recaptcha', {
          'size': 'invisible',
          'callback': (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
            // ...
          }
        }, auth);
        setLoading(false)
      }
    }

  const verifyOtp = (event) => {
    setLoading(true)
    event.preventDefault();
    setErrMsg({});
    
    if (otp.length === 6) {
      // verifu otp
      let confirmationResult = window.confirmationResult;
      confirmationResult.confirm(otp).then((result) => {
     
        setLoading(false)
       
        setErrMsg({cls:'alert alert-success text-center', msg:"OTP verified successfully."});
        
        setHasFilled(false);
        updateUser('phone_update');  
        
      }).catch((error) => {
        setLoading(false)
       
        setErrMsg({cls:'alert alert-danger text-center', msg:"Please insert correct OTP."});
      });
    }else{
      setLoading(false)
        setErrMsg({cls:'alert alert-danger text-center', msg:"OTP length must be 6 digit."});
    }
  }

  const [intelValid,setIntelValid] = useState('');
  const handleIntel = (dv)=>{
    setIntelValid(dv)
  }

  const [passShow, setPassShow] = useState({field:"",show:false});

  const passtoggle=(newFieldValue)=>{
    //console.log(newFieldValue)
      //setPassShow(!passShow)   
      setPassShow((prev) => ({ ...prev, field: newFieldValue, show: !prev.show })); 
  }
 

  return (
    <Layout
      title="My Account Detail | Chaashni Couture">
      <div className={`site-content-wrap my-account ${loading?'loading':''}`}>
        <div className="container">
        <div id="recaptcha"></div>
          {/* JSON.stringify(details) */}
          <div className="row">
            <div className="col-md-12">
              <h1 className="sustom-heading-h1">
                My Account <span>Details</span>
              </h1>
              {errMsg.cls? <div className={errMsg.cls}>{errMsg.msg}</div>:'' }
              <div className="content-box myaccount-page">
                <div className="checkout-section">
                  <h2>Personal Details*</h2>
                  
                  <ul>
                    <li>
                      <input 
                        type="text"
                        name="f_name"
                        className="form-control"
                        required
                        placeholder="First Name"
                        value={details?.f_name}
                        onChange={handleChange}
                      />
                    </li>
                    <li>
                      <input
                        type="text"
                        name="l_name"
                        className="form-control"
                        required
                        placeholder="Last Name"
                        value={details?.l_name}
                        onChange={handleChange}
                      />
                    </li>
                    <li>
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        required
                        placeholder="Email"
                        value={details?.email}
                        onChange={handleChange}
                      />
                    </li>
                    <li className="has-btn">
                      <button className="btn btn-primary" onClick={()=>{updateUser('name_update')}}>  Update </button>
                    </li>
                  </ul>
                </div>

                <div className="checkout-section">
                  <h2>Contact Details*</h2>
                  <ul>
                    <li className="ph-no">
                    {/*
                      {country!==''?(
                      <CountryPhone code={selectedCode} selectedCode={setSelectedCode}/>
                     ):''} 
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      placeholder="Mobile number"
                      value={phoneNo}
                      onChange={handleChange}
                    />
                    */}
                   
                    <div className='login-data mobile-field'>
                      {details?.phone && (
                        <IntlTelInputBox setFullPhone={setFullPhone} selectedPhone={fullPhone} handleIntel={handleIntel}/>
                      )}                     
                    </div>

                  </li>

                  {/* {hasFilled?( */}
                  {hasFilled?(
                    <li className="ph-otp">
                      <div className='otp-field new-otp-field'>
                        {/* <input type="number" placeholder="Enter the OTP" required maxLength={6} className='form-control input-text' value={otp} onChange={(e)=>setOtp(e.target.value)}/> */}
                        <OtpInput shouldAutoFocus={true} skipDefaultStyles={true} inputStyle={'otp-input'}  value={otp}  onChange={setOtp}  numInputs={6}  renderSeparator={<span>-</span>} renderInput={(props) => <input {...props} />} />
                        <button className="btn btn-primary" onClick={verifyOtp}>Verify OTP</button>
                        <div className='new-resend-otp'>
                        <button type='button' onClick={() => resendOTP()} disabled={otpTime > 0}><span>{isButtonDisabled ? "Sending" : "Resend OTP"}</span></button>
                        {otpTime > 0 && <div className='red-text'>({otpTime})</div>}
                        </div>
                    </div>
                    </li>
                    ):''}

                  {/*{!hasFilled?( */}
                  {!hasFilled?(
                    <li className="has-btn">
                    <button className="btn btn-primary" onClick={()=>{handleSend('phone_update')}}>  Update </button>
                    </li>
                    ):''}
                  </ul>
                </div>

                <div className="checkout-section">
                  <h2>Password change <small>(leave blank to leave unchanged)</small></h2>
                  <ul>
                    <li className="showhide-password">
                      <input
                        type={passShow?.show  && passShow?.field==='current_pass'  ? "text" : "password"}
                        name="password"
                        className="form-control"
                        required
                        placeholder="Current password"
                        value={details?.password}
                        onChange={handleChange}
                      />
                      <span className='showhide-btn' onClick={()=>passtoggle('current_pass')}><i className={`fa-solid ${passShow?.show && passShow?.field==='current_pass' ? "fa-eye-slash" : "fa-eye"} `}></i></span>
                    </li>

                    <li className="showhide-password">                     
                      <input
                        type={passShow?.show  && passShow?.field==='new_pass' ? "text" : "password"}
                        name="newPass"
                        className="form-control"
                        required
                        placeholder="New password"
                        value={details?.newPass}
                        onChange={handleChange}
                      />
                       <span className='showhide-btn' onClick={()=>passtoggle('new_pass')}><i className={`fa-solid ${passShow?.show  && passShow?.field==='new_pass' ? "fa-eye-slash" : "fa-eye"} `}></i></span>
                      <div className="password-strength">
                        <PasswordStrengthBar password={details?.newPass} minLength={8} shortScoreWord={'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).'} scoreWords={['Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).', 'Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).','Hint: The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).']}/>
                      </div>
                    </li>

                    <li className="showhide-password">
                      <input
                        type={passShow?.show  && passShow?.field==='confirm_pass' ? "text" : "password"}
                        name="confirmPass"
                        className="form-control"
                        required
                        placeholder="Confirm new password"
                        value={details?.confirmPass}
                        onChange={handleChange}
                      />
                       <span className='showhide-btn' onClick={() => passtoggle('confirm_pass')}><i className={`fa-solid ${passShow?.show  && passShow?.field==='confirm_pass' ? "fa-eye-slash" : "fa-eye"} `}></i></span>
                    </li>
                    <li className="has-btn">
                    <button className="btn btn-primary" onClick={()=>{updateUserPass('password_update')}}>  Update </button>
                    </li>                    
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
